<template>
	<div class="register-fail-page">
		<div class="fail w1200">
			<div class="back" @click="back">&lt;返回</div>
			<div class="infobox">
				<div class="title">基本信息</div>
				<el-row class="grid-demo" :gutter="24" :style="{ 'align-items': 'center' }">
					<el-col :span="24">
						<div class="itemName">企业名称</div>
						<div class="itemInfo">
							{{ companyInfo.companyName }}
							<img :src="`${baseUrl}static/status3.svg`" alt />
						</div>
					</el-col>
				</el-row>
				<el-row class="grid-demo" :gutter="24">
					<el-col :span="24">
						<div class="itemName">拟申请碳足迹认证的产品</div>
						<div class="itemInfo">{{ companyInfo.certifiedProducts }}</div>
					</el-col>
				</el-row>
				<el-row class="grid-demo" :gutter="24" :style="{ 'margin-bottom': '40px' }">
					<el-col :span="24">
						<div class="itemName">企业主营业务简介</div>
						<div class="itemInfo">{{ companyInfo.business }}</div>
					</el-col>
				</el-row>
				<div class="title">企业认证结果</div>
				<div class="failbox">
					<div class="lt">
						<img src="@/assets/img/rzsb.png" alt />
					</div>
					<div class="rt">
						<div class="title">您的企业信息未通过认证 请重新认证</div>
						<ul>
							<li>
								<div class="dian"></div>
								认证驳回原因：{{ remark }}
							</li>
						</ul>
						<el-button type="primary" class="btn" @click="reApply">重新认证</el-button>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Foot from '@/layout/Foot/Foot.vue';
import { FindOrg, InternationalAreaCode } from '@/common/api.js';
import { filterByKey } from '@/common/utils.js';
export default {
	components: {
		Foot
	},
	data() {
		return {
			//
			remark: '',
			//
			areaCode: [],
			//
			orgTypeList: [],
			// 企业信息
			companyInfo: {
				companyName: '',
				//企业产品
				certifiedProducts: '',
				// 主营业务
				business: ''
			}
		};
	},
	created() {
		this.getInfo();
	},
	methods: {
		// 返回
		back() {
			this.$router.back();
		},
		// 重新认证
		reApply () {
		  this.$store.commit('changeRegInfo')
		  this.$router.push({ name: 'registerApply' })
		},
		//
		getMcode() {
			return InternationalAreaCode({ setCode: ['ORG_AUTH_INTERNATIONAL_AREA_CODE', 'ORG_TYPE'] }).then((res) => {
				if (res.success) {
					this.areaCode.push(...res.data.ORG_AUTH_INTERNATIONAL_AREA_CODE);
					this.orgTypeList.push(...res.data.ORG_TYPE);
					return true;
				} else {
					this.$message.error(res.message);
					return false;
				}
			});
		},
		//
		getInfo() {
			this.getMcode().then((flag) => {
				if (flag) {
					FindOrg().then((res) => {
						if (res.success) {
							this.remark = res.data.remark;
							this.companyInfo.companyName = res.data.companyName;
							this.companyInfo.certifiedProducts = res.data.certifiedProducts;
							this.companyInfo.business = res.data.business;
						}
					});
				} else {
					this.$message.error('数据获取失败');
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-row {
			margin-bottom: 20px;
		}
	}
	.register-fail-page {
		min-height: 100vh;
		display: flex;
		flex-direction: column;
	}
.fail {
	padding-bottom: 50px;
	img {
		display: inline-block;
	}
	.infobox {
		width: 850px;
		margin: 0 auto;
		margin-top: 24px;
	}
	.back {
		font-size: 16px;
		height: 68px;
		display: inline-flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
	}
	.title {
		font-size: 20px;
		font-weight: 500;
		line-height: 28px;
		color: var(--color-text-1);
		margin-bottom: 24px;
	}
	.itemName {
		font-size: 14px;
		height: 20px;
		font-weight: 500;
		color: var(--color-text-3);
		line-height: 20px;
		margin-bottom: 8px;
	}
	.itemInfo {
		background: var(--color-fill-2);
		border-radius: 6px;
		color: var(--color-text-2);
		line-height: 20px;
		padding: 6px 8px;
		height: 100%;
		min-height: 32px;
		font-size: 14px;
		display: flex;
		align-items: center;
	}
	.arco-row {
		margin-bottom: 20px;
	}
	.failbox {
		background: rgba(var(--success-5), 0.06);
		border-radius: 6px;
		padding-top: 34px;
		padding-bottom: 34px;
		display: flex;
	}
	
	.lt {
		img {
			height: 134px;
			margin-bottom: 30px;
		}
	}

	.rt {
		margin-left: 48px;
		.title {
			color: rgb(var(--warning-6));
			font-weight: 600;
			line-height: 28px;
		}
	}
	.dian {
		display: inline-block;
		width: 6px;
		height: 6px;
		border-radius: 6px;
		background: rgb(var(--primary-6));
		margin-right: 7px;
		vertical-align: middle;
	}
	ul {
		li {
			color: var(--color-text-2);
			line-height: 20px;
			margin-bottom: 10px;
			font-size: 14px;
		}
	}
	.btn {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0;
		width: 92px;
		height: 32px;
		border-radius: 6px;
		font-size: 14px;
		margin-top: 20px;
		
	}
}
</style>
